"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_select_1 = __importDefault(require("vue-select"));
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
const bmk_ui_framework_2 = __importDefault(require("@biomemakers/bmk_ui_framework"));
const lucide_vue_next_1 = require("lucide-vue-next");
let Select = class Select extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.model = null;
        this.hasFocus = false;
        this.attributes = {
            'ref': 'openIndicator',
            'role': 'presentation',
            'class': 'vs__open-indicator',
        };
    }
    get internal_theme() {
        if (this.theme)
            return this.theme;
        return this.$theme.current.value;
    }
    resetModel() {
        if (this.reset)
            this.model = null;
    }
    emitModel() {
        if (this.hasFocus) {
            this.$emit('modelEmit', this.model);
        }
    }
    updateModel() {
        this.model = this.defaultValue;
    }
    changeValue() {
        this.$emit('input', this.model);
    }
    releaseFocus() {
        this.hasFocus = false;
    }
    triggerFocus() {
        this.hasFocus = true;
    }
    created() {
        this.model = this.defaultValue;
    }
    toggleSelection(value) {
        const index = this.model.indexOf(value);
        if (index > -1) {
            this.model.splice(index, 1);
        }
        else {
            this.model.push(value);
        }
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: null })
], Select.prototype, "theme", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Array, default: [] })
], Select.prototype, "options", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: 'primary' })
], Select.prototype, "accent", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: 'text' })
], Select.prototype, "type", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: 'm' })
], Select.prototype, "size", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: 'Select' })
], Select.prototype, "placeholder", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: null })
], Select.prototype, "defaultValue", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: false })
], Select.prototype, "disabled", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: false })
], Select.prototype, "reset", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: false })
], Select.prototype, "loading", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: false })
], Select.prototype, "multiple", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: false })
], Select.prototype, "clearable", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: true })
], Select.prototype, "searchable", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('reset')
], Select.prototype, "resetModel", null);
__decorate([
    (0, vue_property_decorator_1.Watch)('model')
], Select.prototype, "emitModel", null);
__decorate([
    (0, vue_property_decorator_1.Watch)('defaultValue')
], Select.prototype, "updateModel", null);
Select = __decorate([
    (0, vue_property_decorator_1.Options)({
        name: 'Select',
        emits: ['change', 'input', 'blur', 'focus', 'close', 'update:modelValue'],
        components: {
            vSelect: vue_select_1.default,
            ZeroMatchesSearch: bmk_ui_framework_2.default,
            Loader: bmk_ui_framework_1.Loader,
            ChevronDown: lucide_vue_next_1.ChevronDown,
            ArrowBottomIcon: bmk_ui_framework_1.ArrowBottomIcon
        },
    })
], Select);
exports.default = Select;
